import { render, staticRenderFns } from "./StagingCriterionFormEditModal.vue?vue&type=template&id=2028b7da"
import script from "./StagingCriterionFormEditModal.vue?vue&type=script&lang=ts"
export * from "./StagingCriterionFormEditModal.vue?vue&type=script&lang=ts"
import style0 from "./StagingCriterionFormEditModal.vue?vue&type=style&index=0&id=2028b7da&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports